
import { button } from "@entersekt/types/build/3-5-0/endpoint";
import LoadingComponent from "@/components/LoadingComponent.vue";
import { defineComponent, PropType } from "vue";
import tinycolor from "tinycolor2";

const black = "black";
const white = "white";

const __default__ = defineComponent({
  name: "ButtonComponent",
  components: { LoadingComponent },

  props: {
    button: {
      required: true,
      type: Object as PropType<button>,
    },
    theme: {
      required: true,
      type: String,
    },
    isLoading: {
      type: Boolean,
    },
  },

  computed: {
    textColor() {
      const currentColor = tinycolor(this.theme);
      if (currentColor.isLight()) {
        return black;
      }
      return white;
    },

    onHover(): string {
      const currentColor = tinycolor(this.theme);
      if (currentColor.isLight()) {
        return currentColor.darken(10).toString();
      }
      return currentColor.lighten(10).toString();
    },
  },

  methods: {
    buttonClicked() {
      this.$emit("buttonClicked", this.button.action, this.button.actionNext);
    },
  },

  emits: ["buttonClicked"],
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "e1663388": (_ctx.theme),
  "75712d29": (_ctx.textColor),
  "205a8360": (_ctx.onHover)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__